import { AbstructLang } from "../../../general/general-component/abstruct-component/AbstructLang";

export default function ItemsAccounting() {
    const { translate } = AbstructLang();

    const itemsAccounting = [
        {
            title: translate('accounts'),
            icon: "fa fa-users",
            url: "/accounts",
            id:1
        },
        {
            title: translate('transactions'),
            icon: "fa fa-exchange",
            url: "/transactions",
            id:2
        },
        {
            title: translate('statements'),
            icon: "fa fa-tasks",
            url: "/statements",
            id:3
        },
        {
            title: translate('expenses'),
            icon: "fas fa-chart-pie",
            url: "/expenses",
            id:4
        },
        {
            title: translate('settings_accounting'),
            icon: "fas fa-cog",
            url: "/settings-accounting",
            id:5 
        },
        // {
        //     title: translate('report'),
        //     icon: "fa fa-file-o",
        //     url: "/report-accounting",
        //     id:5 
        // },
    ]
    return {
        itemsAccounting
    }
}


